// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shadow[data-v-87fe8d92] {\n  border: 1px solid white;\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
